module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "projects-list"
  }, _vm._l((_vm.posts), function(post) {
    return _c('li', {
      staticClass: "projects-list__item",
      class: {
        'project-list__item--in-progress': _vm.isInProgress(post.fields.project_status),
          'project-list__item--review': _vm.isInReview(post.fields.project_status),
          'projects-list__item--featured': post.fields.featured === true
      }
    }, [_c('div', {
      staticClass: "box",
      class: {
        'box--cover': post.fields.project_image_size === 'cover',
          'box--contain': post.fields.project_image_size === 'contain'
      }
    }, [_c('a', {
      staticClass: "box__link",
      attrs: {
        "href": post.link
      }
    }, [_c('div', {
      staticClass: "badges"
    }, [(_vm.isInProgress(post.fields.project_status)) ? _c('div', {
      staticClass: "badges__badge badges__badge--in-progress"
    }, [_c('span', {
      staticClass: "badges__badge-text badges__badge-text--in-progress"
    }, [_vm._v("\n                            " + _vm._s(_vm.i18n.inProgress) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.isInReview(post.fields.project_status)) ? _c('div', {
      staticClass: "badges__badge badges__badge--review"
    }, [_c('span', {
      staticClass: "badges__badge-text badges__badge-text--review"
    }, [_vm._v("\n                            " + _vm._s(_vm.i18n.inReview) + "\n                    ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "box__image-wrap"
    }, [_c('blurry-image', {
      staticClass: "box__image",
      attrs: {
        "smallImage": post.fields.project_image['48x38'],
        "largeImage": post.fields.project_image['584x408'],
        "alt": post.title.rendered
      }
    })], 1), _vm._v(" "), _c('h2', {
      staticClass: "box__title",
      domProps: {
        "innerHTML": _vm._s(post.title.rendered)
      }
    })])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8173e396"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/modules/list.vue
// module id = 357
// module chunks = 0